import { MarketPricePill } from '~/components/ui/MarketPricePill';
import { usePreferredUnit } from '~/hooks/usePreferredUnit';
import { formatMarketMidPrice } from '~/utils/marketMidPrice';
import { getPlatformProductDimensions } from '~/utils/order';
import type { BuyListDetailItem } from './types';

export function BuyListItemMarketPrice({
  item,
}: Readonly<{ item: BuyListDetailItem }>) {
  const { latestPriceMid, platformProduct, length, isNominal } =
    item.platformProductsLength;
  const standardUnit = platformProduct.standardUnitsCode;
  const preferredUnit = usePreferredUnit(
    platformProduct.category,
    standardUnit
  );
  if (latestPriceMid == null) return null;

  const price = formatMarketMidPrice(
    latestPriceMid.amount,
    latestPriceMid.currency,
    preferredUnit,
    standardUnit,
    getPlatformProductDimensions(platformProduct, length, isNominal)
  );
  return price == null ? null : <MarketPricePill price={price} />;
}
